import { render, staticRenderFns } from "./aRmsDayRkTooltip.vue?vue&type=template&id=236a567d"
import script from "./aRmsDayRkTooltip.vue?vue&type=script&lang=js"
export * from "./aRmsDayRkTooltip.vue?vue&type=script&lang=js"
import style0 from "./aRmsDayRkTooltip.vue?vue&type=style&index=0&id=236a567d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardTitle,VDataTable,VTooltip})
